export let popups = () => {
	var popup = $('.pop-up'),
		popupContent = $('.pop-up__content'),
		popupContentInit = $('.pop-up__content').html();
		

			
    $('.pop-up-controle').on( 'click keypress', function(e){
		var disc = $(this).data('notes');
			
		if(disc !== undefined){

			popupContent.html('<p>' + disc + '</p>');

		}else{

			popupContent.html(popupContentInit);

		}

		e.preventDefault();

		popup.addClass('pop-up--active');

	});

    // Close
	$('.pop-up-close').on('click keypress', function(e) {
        e.preventDefault();

		popup.removeClass('pop-up--active');

	});

};